import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { Specs } from '../../constants/Specs';
import { isExperimentOn } from '../../utils';
import { canTransferInDomainViaValidationService } from './canTransferInDomainViaValidationService';
import { canTransferInDomainViaWixWar } from './canTransferInDomainViaWixWar';
export const canTransferInDomain = async _ref => {
  let httpClient = _ref.httpClient,
    request = _ref.request;
  const _ref2 = getPremiumEssentialsSafe() ?? {},
    experiments = _ref2.experiments;
  return isExperimentOn(experiments == null ? void 0 : experiments[Specs.TRANSFER_IN_VALIDATION_SERVICE]) ? canTransferInDomainViaValidationService({
    httpClient,
    request
  }) : canTransferInDomainViaWixWar({
    httpClient,
    request
  });
};
//# sourceMappingURL=canTransferInDomain.js.map